document.addEventListener('DOMContentLoaded', function () {
  const subscriptionWrapper = document.querySelector('.subscription_options');
  const subscriptionOptions = subscriptionWrapper.querySelectorAll('input');
  const variantRadios = document.querySelector('variant-radios');

  const json = document.getElementById(subscriptionWrapper.closest('subscription-selector').dataset.json);
  const data = JSON.parse(json.textContent);

  function calculateDiscountPercent(variant) {
    if (variant.compare_at_price > 0) {
      const discount = variant.compare_at_price - variant.price;
      return Math.round((discount / variant.compare_at_price) * 100);
    }
    return 0;
  }

  function updateDiscountPercent(option, variant) {
    if (calculateDiscountPercent(variant) > 0) {
      option.nextElementSibling.querySelector('.percentage .value').innerHTML = calculateDiscountPercent(variant);
    } else {
      option.nextElementSibling.querySelector('.percentage:has(.value)').style.color = 'transparent';
    }
    
    option.nextElementSibling.setAttribute('data-price', variant.price)
    option.nextElementSibling.setAttribute('data-compare', variant.compare_at_price)
  }

  function handleOptionChange(option) {
    const optionName = option.name;
    const optionValue = option.value;
    const correspondingInput = variantRadios.querySelector(
      'input[data-name="' + optionName + '"][value="' + optionValue + '"]'
    );

    correspondingInput.closest('.product-form__input').querySelectorAll("input").forEach(variant => {
      variant.checked = false
    })

    correspondingInput.checked = true;
    correspondingInput.closest('variant-radios').dispatchEvent(new Event('change'))
  }

  function getVariant(variantName) {
    return data.variants.find((variant) => variant.title.toString() === variantName.toString());
  }

  subscriptionOptions.forEach((option) => {
    const variant = getVariant(option.nextElementSibling.dataset.variantName);
    updateDiscountPercent(option, variant);

    option.addEventListener('change', function () {
      let label = option.nextElementSibling
      let selectedSize = Number(label.dataset.size)
      let price = Number(label.dataset.price)
      let compare = Number(label.dataset.compare)

      handleOptionChange(option);

      document.querySelectorAll('[data-single-price]').forEach(el => {
        const formattedPrice = price / 100.0;
        el.innerHTML = formattedPrice;
      });

      if (compare > price) {
        document.querySelector('.subscription__single_compare-at-price').innerHTML = '$' + compare / 100.0;
      } else {
        document.querySelector('.subscription__single_compare-at-price').innerHTML = '';
      }
      const singleLoadElement = document.querySelector('.subscription__single-load [data-single-load]');
      if (singleLoadElement) {
        singleLoadElement.innerHTML = (price / 6000.0 / selectedSize).toFixed(2);
      }
      const singlePackElement = document.querySelector('.subscription__single-load [data-single-pack]');
      if (singlePackElement) {
        const val = (price / (selectedSize * 100)).toFixed(0);
        singlePackElement.innerHTML = val.endsWith('.00') ? val.slice(0, -3) : val;
      }

      // when the Subscription plan changes, update the single pack price
      document.querySelectorAll('.subscription__sub select[data-packages]').forEach((el) => {
        el.addEventListener('change', () => {
          const selectedValue = el.options[el.selectedIndex].value;
          const subscription1Pack = data.variants.find((variant) => variant.option2.toString() === "1 Pack");         
          const selectedPlan = subscription1Pack.selling_plan_allocations.find(allocation => allocation.selling_plan_id.toString() === selectedValue.toString());

          const priceElement = document.querySelector('.subscription__sub span[data-sub-single-pack]');
          if (priceElement) {
            const price = selectedPlan.price / 100.0;
            priceElement.innerText = price.toFixed(0);
          }
        });
      });

    });
  });
});

function hideOptions() {
  const subscriptionWrapper = document.querySelector('.subscription_options:not(.u-do-not-hide)');
  if (!subscriptionWrapper) return;

  const subscriptionOptions = subscriptionWrapper.querySelectorAll('input');

  subscriptionWrapper.style.display = 'none'
  subscriptionWrapper.style.marginTop = '0px'

  subscriptionOptions[0].dispatchEvent(new Event('change'));
}